import { getUserPermissionsByRoles } from '@/services/user.service';

export default {
  namespaced: true,

  state: () => ({
    permissions: {},
    role: null,
    lastFetched: null,
    cacheTimeout: 5 * 60 * 1000, // 5 минут
  }),

  getters: {
    hasPermission: (state) => (permission) => {
      const hasPerm = state.permissions[permission] || false;

      return hasPerm;
    },

    isCacheValid: (state) => (role) => {
      // Check if timeout is valid AND role matches
      const isTimeValid = state.lastFetched && Date.now() - state.lastFetched < state.cacheTimeout;
      const isRoleValid = state.role === role;
      return isTimeValid && isRoleValid;
    },

    permissions: (state) => state.permissions,
  },

  mutations: {
    SET_PERMISSIONS(state, { permissions, role }) {
      state.permissions = permissions;
      state.role = role;
      state.lastFetched = Date.now();
    },

    CLEAR_PERMISSIONS(state) {
      state.permissions = {};
      state.role = null;
      state.lastFetched = null;
    },
  },

  actions: {
    async fetchPermissions({ commit, getters }, payload = {}) {
      const { role, force = false } = payload || {};

      // Если кэш валиден и не принудительно — возвращаем кэш
      if (!force && getters.isCacheValid(role)) {
        return getters.permissions;
      }

      try {
        const resp = await getUserPermissionsByRoles(role);

        const permissions = Array.isArray(resp?.permissions) ? resp.permissions : [];

        const permissionsMap = permissions.reduce((acc, perm) => {
          acc[perm] = true;
          return acc;
        }, {});

        commit('SET_PERMISSIONS', { permissions: permissionsMap, role });
        return permissionsMap;
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
        return {};
      }
    },

    clearCache({ commit }) {
      commit('CLEAR_PERMISSIONS');
    },
  },
};
